import type { Dispatch } from "react";
import type {
	SubmissionTableAction,
	SubmissionTableState,
} from "../SubmissionsTable";
import { searchResponses } from "../children/Search";

function makeSkeletonRows(count = 5) {
	return Array.from({ length: count }, (_, i) => ({
		id: `skeleton-${i}`,
		isLoading: true,
	}));
}

export async function fetchSubmissionTableData(
	state: SubmissionTableState,
	dispatch: Dispatch<SubmissionTableAction>,
	browserLocationId: string,
) {
	try {
		dispatch({ type: "SET_IS_LOADING", payload: true });

		const {
			searchVal,
			selectedForm,
			selectedFormMode,
			selectedSubmissionType,
			pageNum,
			pageSize,
			sortBy,
			sortOrder,
			filters,
			viewingDeleted,
			viewingDrafts,
		} = state;

		const tableParams = {
			searchVal,
			selectedForm: selectedSubmissionType || selectedForm, // Use selectedSubmissionType if available
			selectedFormMode,
			pageNum,
			pageSize,
			sortBy,
			sortOrder,
			browserLocationId,
			filters,
			viewingDeleted,
			viewingDrafts,
		};

		const responses = await searchResponses(tableParams);

		dispatch({ type: "SET_DATA_SOURCE", payload: responses?.results || [] });
		dispatch({ type: "SET_COUNT", payload: responses.count || 0 });
		dispatch({ type: "SET_IS_LOADING", payload: false });
	} catch (exception) {
		console.error(`Failed to search for submissions: ${exception}`);
		dispatch({ type: "SET_IS_LOADING", payload: false });
		throw new Error("Failed to search for submissions");
	}
}
